import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { BrowserRouter } from 'react-router';

import './index.css';
import './i18n';
import { setupGlobalErrorHandlers } from './utils/errorHandler';

// Set up global error handlers for chunk loading errors
setupGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById('root')!);

if (import.meta.env.DEV) {
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
} else {
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
